import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { firstValueFrom } from "rxjs";
import { IServicePoint } from "@models/v2/service-point.model";

@Injectable({
	providedIn: 'root'
})
export class ServicePointService {

	private http = inject(HttpClient);

	async getServicePoints() {
		const result = await firstValueFrom(this.http.get<Record<string, unknown>[]>(`${environment.dataUrl}/v2/servicepoints`));

		const converted = (result ?? []).map(item => toCamelCaseKeys<IServicePoint>(item));
		
		return converted;
	}

	async getServicePointsByCountryCode(countryCode: string) {
		const result = await firstValueFrom(this.http.get<Record<string, unknown>[]>(`${environment.dataUrl}/v2/servicepoints/${countryCode}`));

		const converted = (result ?? []).map(item => toCamelCaseKeys<IServicePoint>(item));

		return converted;
	}

}

function toCamelCaseKeys<T>(value: Record<string, unknown>): T {
	return Object.fromEntries(
		Object.entries(value).map(([key, entry]) => [key.charAt(0).toLowerCase() + key.slice(1), entry])
	) as unknown as T;
}